module.exports = __webpack_public_path__ + "img/tradimundo.47801380.jpg";